// External libraries
import { ApolloClient } from 'apollo-client';

// Internal modules
import { cache } from './cache';
import { getLinks } from './links';
import { requestFactory } from './utils';
import { getGlobals, getLocale, getToken } from '../globals';
import INITIAL_DATA_QUERY from '@/initialDataQuery.graphql';

/**
 * @TO_DO
 *
 * Add an import statement for `unfetch` to `src/lib/polyfills.js` once
 * `graphql-request` has been removed. This is needed because
 * `graphql-request` comes with a polyfill for `fetch()` but `apollo-client`
 * does not.
 */
import 'unfetch';

export const apolloClient = new ApolloClient({
  cache,
  link: getLinks(),
  queryDeduplication: true,
  resolvers: {},
});

// Seed the cache with the initial data query from the server
const { country: countryCode, language: languageCode } = getLocale();
apolloClient.writeQuery({
  data: getGlobals().initialGqlData,
  query: INITIAL_DATA_QUERY,
  variables: {
    countryCode,
    languageCode,
    token: getToken(),
  },
});

export const apolloMutation = requestFactory(apolloClient, 'mutate');

export const apolloQuery = requestFactory(apolloClient, 'query');
